import {closeOverlayInternship} from '../InternshipOverlay/InternshipOverlay';

const pageOverlayActiveClass = 'body--showOverlayFull';
const overlayActiveClass = 'loginOverlay--active';

let overlayButtons: NodeListOf<HTMLElement> = document.querySelectorAll('.js-loginOverlay');
let overlayHide: HTMLElement | null = document.querySelector('.js-overlay');
let loggedInOverlay: HTMLElement | null = document.querySelector('.js-loggedInOverlay');
let reloadPageElement: HTMLElement | null = document.querySelector('.js-reloadPageAfterLogin');
export function loginOverlay() {
  let overlayClose: HTMLElement | null = document.querySelector('.js-overlayClose');

  if (reloadPageElement) {
    setTimeout(() => { window.location.search = ''; }, 5000);
  }

  overlayButtons.forEach((overlay) => {
    overlay.addEventListener('click', (event: Event) => {
      if (overlay.querySelector('.js-loggedIn')) {
        loggedInOverlay?.classList.toggle('hide');
      } else {
        overlay.classList.add(overlayActiveClass);
        document.body.classList.add(pageOverlayActiveClass);
        overlayHide?.classList.remove('hide');
      }
    });

    if (document.URL.search('tx_felogin_login') > 0) {
      overlay.classList.add(overlayActiveClass);
      document.body.classList.add(pageOverlayActiveClass);
      overlayHide?.classList.remove('hide');
    }
  });

  if (overlayClose) {
    overlayClose.addEventListener('click', (event: Event) => {
      closeOverlay();
      closePageOverlay();
    });
  }

  /* close navigation on escape key or click on page overlay */
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeOverlay();
      closePageOverlay();
    }
  });
  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;
    if (target.classList.contains(pageOverlayActiveClass)) {
      closeOverlayInternship();
      closeOverlay();
      closePageOverlay();
    }
  });
}

function closePageOverlay () {
  document.body.classList.remove(pageOverlayActiveClass);
}

function closeOverlay () {
  overlayButtons.forEach((overlay) => {
    overlay.classList.remove(overlayActiveClass);
    overlayHide?.classList.add('hide');
  });
}
